import { useTheme } from "@mui/system";
import Joyride from "react-joyride";
import useTour from "../hooks/tour.hook";
import { JoyrideSoothTooltip } from ".";
import { useIsMobile } from "hooks/is-mobile.hook";

export default function TourProvider() {
  const { palette, zIndex } = useTheme();
  const isMobile = useIsMobile();
  const { runTour, stepIndex, handleTour, steps, key, tour, debug } = useTour({
    debug: Boolean(Number(process.env.REACT_APP_DEV_TOOLS)),
  });
  if (!Boolean(Number(process.env.REACT_APP_TOURS_ENABLED)) || isMobile) {
    return null;
  }
  return (
    runTour && (
      <Joyride
        callback={handleTour}
        continuous
        debug={debug}
        disableCloseOnEsc
        disableOverlayClose
        // disableScrolling
        floaterProps={{
          debug,
        }}
        hideBackButton
        hideCloseButton
        key={key}
        ref={tour}
        run={runTour}
        scrollOffset={150}
        showSkipButton
        stepIndex={stepIndex}
        steps={steps == null ? [] : steps}
        styles={{
          //   floaterStyles: {
          //     arrow: ({ placement }) => {
          //       console.log(placement);
          //       if (placement === "bottom") {
          //         return {
          //           color: palette.secondary.main,
          //         };
          //       }
          //       return {
          //         color:
          //           palette.mode === "dark"
          //             ? "#313131"
          //             : palette.background.paper,
          //       };
          //     },
          //   },
          options: {
            arrowColor: "#1b99e8",
              // palette.mode === "dark" ? "#313131" : palette.background.paper,
            backgroundColor: palette.secondary.main,
            overlayColor:
              palette.mode === "dark"
                ? "rgb(255, 255, 255, 0.4)"
                : "rgb(0, 0, 0, 0.5)",
            primaryColor: palette.primary.main,
            textColor: palette.text.primary,
            zIndex: zIndex.modal,
          },
        }}
        tooltipComponent={JoyrideSoothTooltip}
      />
    )
  );
}
